/**
 * @file steps
 * @author (gaojie15@baidu.com)
 */
import React, {useState} from 'react';
import {Button} from '@baidu/spui';
import PropTypes from 'prop-types';
import Steps from './steps';
export default function xmods(props) {
    const [isPC, setisPc] = useState(true);
    return (
        <>
            <div className={'mod3 textC'}>
                <div className="top-title">政府/非盈利机构 号码免费认证</div>
                <Steps current={'2'} />
                <div className="x-mod3">
                    <img src={require('../../asset/img/attest/success.png')} alt="" width={'240px'} />
                    <div className={'mt24'}>
                        您当前提交的资质和号码，已经到审核阶段，工作人员正在快马加鞭的进行审核
                        <br />
                        我们会在7个工作日内完成审核，请您耐心等待
                        <br />
                        <br />
                        <Button label={'查看详情'} styleType={'ghost'} onClick={props.backhandle} />
                    </div>
                </div>
            </div>
            <div className="x-more">
                <h4>认证更多号码，获得更多曝光展示</h4>
                <div className="xi-tab">
                    <span onClick={() => setisPc(true)} className={isPC ? 'act' : ''}>
                        pc端
                    </span>
                    <span onClick={() => setisPc(false)} className={!isPC ? 'act' : ''}>
                        移动端
                    </span>
                </div>
                {isPC ? (
                    <img
                        src={require('../../asset/img/attest/intro/morepc.png')}
                        width={'1200px'}
                        style={{verticalAlign: 'middle'}}
                    />
                ) : (
                    <img
                        src={require('../../asset/img/attest/intro/morewise.png')}
                        width={'1200px'}
                        style={{verticalAlign: 'middle'}}
                    />
                )}

                <div className="xm-btn">
                    <a
                        href="/attest"
                        // href="https://console.bce.baidu.com/spns/#/service/enterprise-num-auth"
                        rel="noopener noreferrer"
                        // target="_blank"
                        className="xi-btn"
                    >
                        前往认证
                    </a>
                </div>
            </div>
        </>
    );
}
xmods.propTypes = {
    backhandle: PropTypes.function
};